require('./sms-campaigns.scss')

module.exports = {
  template: require('./sms-campaigns.pug')()
  controller: require('./sms-campaigns.ctrl')
}
